import React, { FormEvent, useState } from "react";
import Spinner from "components/ui/Spinner/Spinner";
import { useAuth } from "context/AuthContext";
import { useI18n } from "context/I18nContext";
// import LanguageSwitcher from "components/ui/LanguageSwitcher/LanguageSwitcher";
import styles from "./LoginPage.module.scss";

function LoginPage() {
  const { login, loading } = useAuth();
  const { t } = useI18n();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    try {
      await login({ username, password });
    } catch (err) {
      setError((err as Error).message || "Unable to login.");
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          {/* <LanguageSwitcher variant="inline" /> Language switcher disabled while English-only */}
        </div>
        <div className={styles.logo}>
          <img src="/logo.png" alt="Wasa" />
        </div>
        <div>
          <h1 className={styles.title}>{t("login.title")}</h1>
          <p className={styles.subtitle}>{t("login.subtitle")}</p>
        </div>
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.field}>
            <label className={styles.label} htmlFor="username">
              {t("login.username")}
            </label>
            <input
              id="username"
              type="text"
              className={styles.input}
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              disabled={loading}
            />
          </div>
          <div className={styles.field}>
            <label className={styles.label} htmlFor="password">
              {t("login.password")}
            </label>
            <input
              id="password"
              type="password"
              className={styles.input}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              disabled={loading}
            />
          </div>
          {error && <div className={styles.error}>{error}</div>}
          <button className={styles.button} type="submit" disabled={loading}>
            {loading ? <Spinner label={t("login.signingIn")} size="sm" /> : t("login.signIn")}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
